/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	images: [],
	vehicle: {}
};

const vehicleImagesSlice = createSlice({
	name: 'vehicleImages',
	initialState,
	reducers: {
		vehicleImagesReceived(state, action) {
			state.images = action.payload.images;
			state.vehicle = action.payload.vehicle || {};
		}
	}
});

export const { vehicleImagesReceived } = vehicleImagesSlice.actions;

export default vehicleImagesSlice.reducer;
